import React, { ReactNode } from "react";
import { Divider, Stack } from "@mui/material";

export const SettingsSections = ({
  children,
  testId,
}: {
  children: ReactNode;
  testId?: string;
}) => (
  <Stack divider={<Divider />} spacing={2} data-testid={testId}>
    {children}
  </Stack>
);

export const SettingsFieldGroup = ({ children }: { children: ReactNode }) => (
  <Stack spacing={4} px={4} py={2}>
    {children}
  </Stack>
);
